import { api } from "@/lib/store";

// ---- Pubblico ----
export const valuationConfig = async () => (await api.get("/valuation/config")).data;
export const valuationEstimate = async (payload) => (await api.post("/valuation/estimate", payload)).data;
export const valuationSubmit = async (payload) => (await api.post("/valuation/submit", payload)).data;
export const valuationGet = async (vid) => (await api.get(`/valuation/${vid}`)).data;

// ---- Admin: modelli ----
export const vModels = async () => (await api.get("/admin/valuation/models")).data;
export const vCreateModel = async (p) => (await api.post("/admin/valuation/models", p)).data;
export const vPatchModel = async (mid, p) => (await api.patch(`/admin/valuation/models/${mid}`, p)).data;
export const vDeleteModel = async (mid) => (await api.delete(`/admin/valuation/models/${mid}`)).data;

// ---- Admin: benchmark ----
export const vBenchmarks = async (params = {}) => (await api.get("/admin/valuation/benchmarks", { params })).data;
export const vAddBenchmark = async (p) => (await api.post("/admin/valuation/benchmarks", p)).data;
export const vBenchmarkAlert = async () => (await api.get("/admin/valuation/benchmark-alert")).data;
export const vBenchmarkHistory = async (model_id) => (await api.get("/admin/valuation/benchmark-history", { params: { model_id } })).data;
export const vBenchmarkCheck = async () => (await api.post("/admin/valuation/benchmark-check")).data;
export const vProposals = async (params = {}) => (await api.get("/admin/valuation/benchmark-proposals", { params })).data;
export const vCreateProposal = async (p) => (await api.post("/admin/valuation/benchmark-proposals", p)).data;
export const vApproveProposal = async (pid) => (await api.post(`/admin/valuation/benchmark-proposals/${pid}/approve`)).data;
export const vRejectProposal = async (pid, reason) => (await api.post(`/admin/valuation/benchmark-proposals/${pid}/reject`, { reason })).data;

// ---- Admin: config ----
export const vGetConfig = async () => (await api.get("/admin/valuation/config")).data;
export const vPutConfig = async (p) => (await api.put("/admin/valuation/config", p)).data;
export const vConfigHistory = async () => (await api.get("/admin/valuation/config/history")).data;

// ---- Admin: simulatore ----
export const vSimulate = async (p) => (await api.post("/admin/valuation/simulate", p)).data;

// ---- Admin: versioni algoritmo (2E) ----
export const vAlgoVersions = async () => (await api.get("/admin/valuation/algorithm-versions")).data;
export const vAlgoCreate = async (p) => (await api.post("/admin/valuation/algorithm-versions", p)).data;
export const vAlgoPatch = async (id, p) => (await api.patch(`/admin/valuation/algorithm-versions/${id}`, p)).data;
export const vAlgoActivate = async (id) => (await api.post(`/admin/valuation/algorithm-versions/${id}/activate`)).data;
export const vAlgoArchive = async (id) => (await api.post(`/admin/valuation/algorithm-versions/${id}/archive`)).data;
export const vAlgoCompare = async (a, b) => (await api.get("/admin/valuation/algorithm-versions/compare", { params: { a, b } })).data;
export const vBenchmarkCheckState = async () => (await api.get("/admin/valuation/benchmark-check/state")).data;

// ---- Admin: agenda valutazioni ----
export const vValuations = async (params = {}) => (await api.get("/admin/valuation/valuations", { params })).data;
export const vValuationDetail = async (vid) => (await api.get(`/admin/valuation/valuations/${vid}`)).data;
export const vPatchValuation = async (vid, p) => (await api.patch(`/admin/valuation/valuations/${vid}`, p)).data;
export const vVerify = async (vid, p) => (await api.post(`/admin/valuation/valuations/${vid}/verify`, p)).data;
export const vPurchase = async (vid, p) => (await api.post(`/admin/valuation/valuations/${vid}/purchase`, p)).data;

export const V_STATUSES = ["NUOVA_RICHIESTA", "DA_CONTATTARE", "APPUNTAMENTO_RICHIESTO", "CONFERMATO",
  "RIPROGRAMMATO", "PRESENTATO", "VERIFICA_IN_CORSO", "ACQUISTATO", "NON_ACQUISTATO",
  "ANNULLATO", "SCADUTO", "MANCATO_APPUNTAMENTO"];

export const V_STATUS_META = {
  NUOVA_RICHIESTA: { label: "Nuova Richiesta", cls: "bg-blue-500/15 text-blue-400" },
  DA_CONTATTARE: { label: "Da Contattare", cls: "bg-amber-500/15 text-amber-400" },
  APPUNTAMENTO_RICHIESTO: { label: "Appuntamento Richiesto", cls: "bg-indigo-500/15 text-indigo-400" },
  CONFERMATO: { label: "Confermato", cls: "bg-emerald-500/15 text-emerald-400" },
  RIPROGRAMMATO: { label: "Riprogrammato", cls: "bg-orange-500/15 text-orange-400" },
  PRESENTATO: { label: "Presentato", cls: "bg-cyan-500/15 text-cyan-400" },
  VERIFICA_IN_CORSO: { label: "Verifica in Corso", cls: "bg-purple-500/15 text-purple-400" },
  ACQUISTATO: { label: "Acquistato", cls: "bg-teal-500/15 text-teal-400" },
  NON_ACQUISTATO: { label: "Non Acquistato", cls: "bg-rose-500/15 text-rose-400" },
  ANNULLATO: { label: "Annullato", cls: "bg-zinc-500/15 text-zinc-400" },
  SCADUTO: { label: "Scaduto", cls: "bg-zinc-500/15 text-zinc-400" },
  MANCATO_APPUNTAMENTO: { label: "Mancato Appuntamento", cls: "bg-rose-500/15 text-rose-400" },
};
